import { render } from "./CloudMDTermsAndConditionsText.vue?vue&type=template&id=93460eba&scoped=true"
import script from "./CloudMDTermsAndConditionsText.vue?vue&type=script&lang=js"
export * from "./CloudMDTermsAndConditionsText.vue?vue&type=script&lang=js"

import "./CloudMDTermsAndConditionsText.vue?vue&type=style&index=0&id=93460eba&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93460eba"]])

export default __exports__